/** @jsx jsx */
import { Elevation } from '@blueprintjs/core';
import { css, jsx } from '@emotion/core';
import { Fragment, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import PaginatedTable from '../../../components/PaginatedTable';
import PaginationBar from '../../../components/PaginationBar';
import { useCompanionFutureSignupsQuery } from '../../../generated/graphql';
import { dummyFutureSignups } from '../../matching/dummy';
import FutureSignupListItem from '../../../components/FutureSignupListItem';

const CompanionFutureSignups = () => {
  const [futureSignupPage, setFutureSignupPage] = useState(1);
  const { companionId } = useParams();

  const { data, loading, error } = useCompanionFutureSignupsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: companionId || '',
      first: 10,
      page: futureSignupPage,
    },
  });

  const { data: futureSignups, paginatorInfo } = data?.companion?.future_signups || {};
  const { currentPage, lastPage, hasMorePages } = paginatorInfo || {};

  return (
    <ContentCard elevation={Elevation.TWO} css={styles.spacedCard}>
      <ContentCardHeader
        leftElement={
          <Fragment>
            <span css={styles.heading}>Anmeldungen</span>
          </Fragment>
        }
      />
      <PaginatedTable
        columns={['Veranstaltung', 'Status', 'Datum']}
        loading={loading}
        hasError={!!error}
        empty={!futureSignups?.length}
      >
        {(loading ? dummyFutureSignups : futureSignups || []).map((futureSignup) => (
          <FutureSignupListItem key={futureSignup.id} signup={futureSignup} skeleton={loading} />
        ))}
      </PaginatedTable>
      <PaginationBar
        loading={loading}
        empty={!futureSignups?.length}
        currentPage={currentPage}
        lastPage={lastPage}
        hasMorePages={hasMorePages}
        onPrev={() => setFutureSignupPage(currentPage && currentPage > 0 ? currentPage - 1 : 1)}
        onNext={() => setFutureSignupPage(currentPage ? currentPage + 1 : 1)}
      />
    </ContentCard>
  );
};

export default CompanionFutureSignups;

const styles = {
  heading: css`
    font-size: 16px;
  `,
  spacedCard: css`
    margin-bottom: 20px;
  `,
};
